import * as React from 'react';
import { route, ILocationService, IScope } from 'angular';
import axios from 'axios';
import { getInternalShowingDetailsUrl } from 'utils';
import { BuildJsonType, EnhancedAppointment } from '@bb/domain/dist/types';
import errorReporter from '@app/errorReporter';

import { Loading, PanelBody, PanelHeader } from '../react-common';
import CoopCancelAppointmentComponent from '../DashboardComponents/CoopCancelAppointmentComponent';
import { getCoopAppointmentById } from './ManageAppointmentPage/APIService';

interface CoopCancelAppointmentPageProps {
  $routeParams: route.IRouteParamsService;
  $location: ILocationService;
  $scope: IScope;
  ToastService: any;
}

interface CoopCancelAppointmentPageState {
  isLoading: boolean;
  appointment: BuildJsonType<EnhancedAppointment>;
}

class CoopCancelAppointmentPage extends React.Component<
  CoopCancelAppointmentPageProps,
  CoopCancelAppointmentPageState
> {
  constructor(props: CoopCancelAppointmentPageProps) {
    super(props);
    this.state = {
      isLoading: true,
      appointment: null,
    };
  }

  async componentDidMount() {
    const { $routeParams, $scope, $location, ToastService } = this.props;

    const { appointment } = await getCoopAppointmentById(
      $routeParams.appointmentId,
    );

    if (appointment.status === 'cancel') {
      $scope.$apply(() => {
        $location.path(
          getInternalShowingDetailsUrl($routeParams.appointmentId),
        );
        ToastService.add({
          message: 'The showing has already been cancelled.',
        });
      });
    }

    this.setState({ isLoading: false });
  }

  setCancelStatus = async (reason: string, details: string) => {
    const { $routeParams, $scope, $location, ToastService } = this.props;

    this.setState({
      isLoading: true,
    });
    try {
      await axios.post(
        `/user/coop/appointments/${$routeParams.appointmentId}/status`,
        {
          status: 'cancel',
          details,
        },
      );
    } catch (err) {
      errorReporter.error(err);
      this.setState({
        isLoading: false,
      });
      return $scope.$apply(() => {
        ToastService.add({
          type: 'danger',
          message: 'Failed to cancel the appointment',
        });
      });
    }

    return $scope.$apply(() => {
      ToastService.add({
        type: 'success',
        message: 'The showing has been cancelled.',
      });
      $location.path(getInternalShowingDetailsUrl($routeParams.appointmentId));
    });
  };

  render() {
    const { isLoading } = this.state;
    const { $routeParams } = this.props;

    if (isLoading) return <Loading size="fa-5x" />;

    return (
      <>
        <PanelHeader
          title={
            <>
              <a
                className="btn btn-primary btn-sm"
                href={getInternalShowingDetailsUrl($routeParams.appointmentId)}
              >
                <i className="fa fa-chevron-left"></i> Back
              </a>{' '}
              Cancel Showing
            </>
          }
        />
        <PanelBody>
          <div style={{ width: '100%' }}>
            <div className="row appointment-details">
              <div className="col-md-6">
                <CoopCancelAppointmentComponent
                  setCancelStatus={this.setCancelStatus}
                />
              </div>
            </div>
          </div>
        </PanelBody>
      </>
    );
  }
}

export default CoopCancelAppointmentPage;
